(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Settings.Agency.User.CRM",
                {
                    url: "/CRM",
                    component: "agentCRM",
                    resolve: {
                        users: ["userApi", "_", function (userApi) {
                            return userApi.getUsers();
                        }],
                        hasCapacity: ["users", "userRegistrationApi", "tenantUserCapacityApi", "_", function (users, userRegistrationApi, tenantUserCapacityApi, _) {
                            var inactiveUsers = _.filter(users,
                                function (user) {
                                    return !user.IsActive;
                                });

                            return userRegistrationApi.getAllIncompleteUserRegistrations().then(
                                function (registrations) {
                                    return tenantUserCapacityApi.getAll().then(function (capacities) {
                                        var userCapacity = 0;
                                        var today = new Date();

                                        ng.forEach(capacities,
                                            function (capacity) {
                                                if (today < new Date(capacity.ExpirationDate))
                                                    userCapacity += capacity.UserCapacity;
                                            });

                                        return userCapacity >
                                            (registrations.length + users.length - inactiveUsers.length);
                                    });
                                });
                        }],
                        adminCount: ["users", "_", function (users, _) {
                            var activeUsers = _.filter(users,
                                function (user) {
                                    return user.IsActive;
                                });
                            return _.filter(activeUsers,
                                function (au) {
                                    return au.Roles.includes("Admin");
                                }).length;
                        }]
                    },
                    data: {
                        pageTitle: "CRM"
                    },
                    onEnter: ["$state", "currentUser", function($state, currentUser) {
                        if (!currentUser.Roles.includes("Admin"))
                            return $state.target("Home.401");
                    }] 
                });
        }
    ]);

    app.component("agentCRM",
        {
            templateUrl: "/App/Settings/Agency/User/CRM/crm-template.html",
            controller: agentCrmController,
            bindings: {
                user: "<",
                currentUser: "<",
                hasCapacity: "<",
                adminCount: "<"
            }
        });

    agentCrmController.$inject = ["roles", "userApi", "_", "subUserApi", "$mdDialog"];
    function agentCrmController(roles, userApi, _, subUserApi, $mdDialog) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {},
                roles: roles,
                updateRoles: updateRoles,
                searchUsers: searchUsers,
                addSubUser: addSubUser,
                removeSubUser: removeSubUser,
                updateIsActive: updateIsActive
            });

        function updateRoles(r, $event) {
            if (!$ctrl.user.Roles.includes(r.Value)) {
                if (r.Value === "Standard" && $ctrl.adminCount === 1) {
                    var alert = $mdDialog.alert({
                        theme: "",
                        title: "Please give another user the Admin Role before removing it from this user.",
                        targetEvent: $event,
                        ariaLabel: "Unable to remove",
                        ok: "Ok",
                        multiple: true,
                        clickOutsideToClose: false
                    });
                    $mdDialog.show(alert);
                }
                else {
                    $ctrl.user.Roles = [r.Value];
                    var confirm = $mdDialog.confirm({
                        theme: "",
                        title: "Are you sure you want to update this user's role?",
                        targetEvent: $event,
                        ariaLabel: "Confirm role update",
                        ok: "update",
                        cancel: "Cancel",
                        multiple: true,
                        clickOutsideToClose: false
                    });
                    r.Value === "Admin" ? $ctrl.adminCount = $ctrl.adminCount + 1 : $ctrl.adminCount = $ctrl.adminCount - 1;
                    $mdDialog.show(confirm).then(function () {
                        return userApi.update($ctrl.user);
                    },
                        function () { });
                }
            }

        }

        // this may be used when custom roles are added in the future:

        //function updateRoles(r, $event) {
        //    var index = _.findIndex($ctrl.user.Roles, function (row) { return row === r.Value; });

        //    var confirm = $mdDialog.confirm({
        //        focusOnOpen: false,
        //        theme: (index === -1 ? "confirmDelete" : ""),
        //        title: "Are you sure you want to " + (index === -1 ? "add" : "remove") + " this role?",
        //        targetEvent: $event,
        //        ariaLabel: "Confirm role update",
        //        ok: (index === -1 ? "add" : "remove"),
        //        cancel: "Cancel",
        //        multiple: true,
        //        clickOutsideToClose: false
        //    });
        //    $mdDialog.show(confirm).then(function () {
        //        if (index === -1)
        //            $ctrl.user.Roles.push(r.Value);
        //        else
        //            $ctrl.user.Roles.splice(index, 1);
        //        return userApi.update($ctrl.user);
        //    },
        //        function () { });
        //}

        function updateIsActive($event) {
            var confirm;
            if ($ctrl.user.IsActive || $ctrl.hasCapacity) {
                confirm = $mdDialog.confirm({
                    focusOnOpen: ($ctrl.user.IsActive ? false : true),
                    title: "Are you sure you want to " +
                    ($ctrl.user.IsActive ? "deactivate" : "activate") +
                    " this user?",
                    targetEvent: $event,
                    ariaLabel: "Confirm user active",
                    ok: "Yes",
                    cancel: "No",
                    multiple: true,
                    clickOutsideToClose: false
                });
                $mdDialog.show(confirm).then(function () {
                    $ctrl.user.IsActive = !$ctrl.user.IsActive;
                    $ctrl.hasCapacity = true;
                    return userApi.setIsActive($ctrl.user.Id, $ctrl.user);
                },
                    function () { });
            } else {
                confirm = $mdDialog.alert({
                    focusOnOpen: false,
                    title: "Additional seats must be purchased or another user must be deactivated in order to activate this user.",
                    targetEvent: $event,
                    ariaLabel: "capacity reached",
                    ok: "Okay",
                    clickOutsideToClose: false
                });
                $mdDialog.show(confirm);
            }


        }

        function searchUsers(term) {
            return userApi.searchUsers(term).then(function (result) {
                result = _.filter(result,
                    function (row) {
                        return row.Id !== $ctrl.user.Id &&
                            !_.find($ctrl.subUsers, function (sub) { return sub.UserId === row.Id; });
                    });
                ng.forEach(result,
                    function (row) {
                        row.Term = row.FirstName + " " + row.LastName;
                    });
                return result;
            });
        }

        function addSubUser(user, $event) {
            if (user) {
                var confirm = $mdDialog.confirm({
                    title: "Are you sure you want to add this sub user?",
                    targetEvent: $event,
                    ariaLabel: "Confirm add sub user",
                    ok: "Add",
                    cancel: "Cancel",
                    multiple: true,
                    clickOutsideToClose: false
                });
                $mdDialog.show(confirm).then(function () {
                    var model = {
                        ParentUserId: $ctrl.user.Id,
                        ChildUserId: user.Id
                    };

                    var subUser = {
                        UserId: user.Id,
                        User: user
                    }
                    $ctrl.subUsers.push(subUser);

                    return subUserApi.create(model).then(function (response) {
                        subUser.SubUserId = response.Id;
                        $ctrl.ui.searchText = null;
                    });
                },
                    function () { });
            }
        }

        function removeSubUser(s, $event) {
            var confirm = $mdDialog.confirm({
                theme: "confirmDelete",
                title: "Are you sure you want to remove this sub user?",
                targetEvent: $event,
                ariaLabel: "Confirm remove sub user",
                ok: "Remove",
                cancel: "Cancel",
                multiple: true,
                onComplete: function() {
                    var $dialog = ng.element(document.querySelector("md-dialog"));
                    var $actionsSection = $dialog.find("md-dialog-actions");
                    var $cancelButton = $actionsSection.children()[0];
                    $cancelButton.focus();
                }
            });
            $mdDialog.show(confirm).then(function () {
                _.remove($ctrl.subUsers,
                    function (subUser) {
                        return subUser.SubUserId === s.SubUserId;
                    });

                return subUserApi.delete(s.SubUserId);
            }, function () { });
        }

        $ctrl.$onInit = () => {
            $ctrl.ui.loadingSubUsers = true;
            subUserApi.getChildren($ctrl.user.Id).then(function (response) {
                $ctrl.subUsers = response || [];
                $ctrl.ui.loadingSubUsers = false;
            });
        }
    }

})(window.app, window.angular); //jshint ignore:line